document
	.querySelectorAll('[id^="ExpandingRowDetails-"] summary')
	.forEach((summary) => {
		summary.setAttribute('role', 'button');

		if (summary.nextElementSibling.getAttribute('id')) {
			summary.setAttribute('aria-controls', summary.nextElementSibling.id);
		}

		summary.addEventListener('click', (event) => {
			if (event.currentTarget.classList.contains('expanded')) {
				event.currentTarget.classList.remove('expanded');
			} else {
				event.currentTarget.classList.add('expanded');
			}
		});

		if (summary.closest('header-drawer, menu-drawer')) return;
		summary.parentElement.addEventListener('keyup', onKeyUpEscape);
	});
